module.exports = __webpack_public_path__ + "static/access01-e285d1617f1ffd4e30a56809291f7abb.jpg";